import React from 'react';
type SectionIntroProps = {
  eyebrow: string;
  title: React.ReactNode;
  body?: string;
  tone?: 'dark' | 'light';
  className?: string;
};
export function SectionIntro({
  eyebrow,
  title,
  body,
  tone = 'dark',
  className = ''
}: SectionIntroProps) {
  const dark = tone === 'dark';
  return <div className={`max-w-2xl ${className}`} data-id="element-457" data-mp="1m23xd05nzrzz">
      <p className={`flex items-center gap-2.5 font-mono text-[10px] uppercase tracking-[0.24em] ${dark ? 'text-forge-cyan' : 'text-navy-500'}`} data-id="element-458" data-mp="1m3f1x26xp3s5">
        <span className="h-px w-7 bg-forge-orange" aria-hidden="true" data-id="element-459" data-mp="2erkoluhjt2um" />
        {eyebrow}
      </p>
      <h2 className={`mt-4 font-display text-[1.65rem] font-extrabold leading-[1.12] tracking-[-0.01em] sm:text-[2.1rem] lg:text-[2.4rem] ${dark ? 'text-white' : 'text-navy-900'}`} data-id="element-460" data-mp="29yrjv6m2xuij">
        {title}
      </h2>
      {body && <p className={`mt-4 text-[15px] leading-relaxed ${dark ? 'text-mist-300' : 'text-navy-700/80'}`} data-id="element-461" data-mp="2xpnhikd7vjxp">{body}</p>}
    </div>;
}